import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { CalendarIcon, X } from "lucide-react";
import { format } from "date-fns";

export function DateRangeFilter({ startDate, endDate, onStartChange, onEndChange, onClear }) {
  const hasFilter = startDate || endDate;

  return (
    <div className="flex items-center gap-2" data-testid="date-range-filter">
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={`h-9 text-xs justify-start font-normal ${startDate ? 'border-sage/50 text-sage' : 'text-stone-dark/50'}`}
            data-testid="date-range-start"
          >
            <CalendarIcon className="w-3.5 h-3.5 mr-1.5" />
            {startDate ? format(startDate, "MMM d, yyyy") : "From"}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={startDate}
            onSelect={onStartChange}
            initialFocus
          />
        </PopoverContent>
      </Popover>
      <span className="text-stone-dark/30 text-xs">to</span>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={`h-9 text-xs justify-start font-normal ${endDate ? 'border-sage/50 text-sage' : 'text-stone-dark/50'}`}
            data-testid="date-range-end"
          >
            <CalendarIcon className="w-3.5 h-3.5 mr-1.5" />
            {endDate ? format(endDate, "MMM d, yyyy") : "To"}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={endDate}
            onSelect={onEndChange}
            initialFocus
          />
        </PopoverContent>
      </Popover>
      {hasFilter && (
        <button
          onClick={onClear}
          className="h-6 w-6 rounded-full bg-stone/50 hover:bg-stone flex items-center justify-center text-stone-dark/50 hover:text-stone-dark transition-colors"
          title="Clear date filter"
          data-testid="date-range-clear"
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}
